export default {
  namespaced: true,
  axis_body_cam: {
    title: 'Axis Body Cam',
    overview: {
      title: 'Overview',
      devices: 'Cameras',
      users: 'Users',
      recordings: 'Recordings',
      total: 'Total',
      active: 'Active',
      today: 'Today',
      transferring: 'Transferring',
      complete: 'Complete',
      storage_used: 'Storage used',
      recent_recordings: 'Recent recordings',
      configure_dock: 'Body Worn Collector Configuration',
      configure_dock_hint: 'Download the connection file to register a dock in Body Worn Manager',
    },
    devices: {
      title: 'Cameras',
      serial_number: 'Serial',
      model: 'Model',
      name: 'Name',
      active: 'Active',
      assigned_user: 'Assigned user',
      system_controller: 'Dock',
      recordings_count: 'Recordings',
      last_synced_at: 'Last synced',
      device_tag: 'Tag',
      reseller: 'Reseller',
      proxy_rtsp_server: 'Stream (inherited from dock)',
      no_locations_for_day: 'No locations recorded for that day',
    },
    system_controllers: {
      title: 'Docks',
      serial_number: 'Serial',
      model: 'Model',
      name: 'Name',
      units: 'Units',
      devices_count: 'Cameras',
      last_synced_at: 'Last synced',
      proxy_rtsp_server: 'Stream',
      users: 'Users with access',
      groups: 'Groups with access',
    },
    users: {
      title: 'Users',
      name: 'Name',
      active: 'Active',
      devices_count: 'Cameras',
      recordings_count: 'Recordings',
      last_synced_at: 'Last synced',
    },
    recordings: {
      title: 'Recordings',
      container_name: 'Session',
      user: 'User',
      device: 'Camera',
      start_time: 'Start',
      stop_time: 'End',
      status: 'Status',
      files: 'Files',
      download: 'Download',
      no_files: 'No files',
      play: 'Play',
      download_all: 'Download all',
      download_started: 'Download started',
      links_error: 'Could not get the recording links',
      part: 'Part',
      playing: 'Playing',
      unsupported_format: 'This browser cannot play MKV, use Chrome/Edge or download the file',
      part_error: 'This part could not be played',
      no_videos: 'This recording has no video',
    },
  },
}
